export default {"src":"/_next/static/media/QRTEA.b7115356.svg","height":18,"width":18};